export default class Rental {
  constructor(
    room,
    housemate,
    arrival,
    {
      departure,
      cancelled,
      confirmationCode,
      houseCode,
      channel,
      companions
    } = {}
  ) {
    this.room = room
    this.housemate = housemate
    this.arrival = arrival
    this.departure = departure
    this.cancelled = cancelled
    this.confirmationCode = confirmationCode
    this.houseCode = houseCode
    this.channel = channel
    this.companions = companions
  }
  addProperty(property) {
    this.property = property
  }
  addPropertyName(propertyName) {
    this.propertyName = propertyName
  }
  addPriority(priority) {
    this.priority = priority
  }
  addFavorite(favorite) {
    this.favorite = favorite
  }
}
